export enum FunnelCreationStatusEnum {
  Completed = 'completed',
  Duplication = 'duplication',
  Sharing = 'sharing',
}
